import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/** Fetch (and cache) the platform fee config once per session so pay pages can render
 *  a live surcharge preview. Returns {invoice_card_fee_pct, transaction_fee_pct}. */
let _cached = null;
let _fetching = null;

export function useFeeConfig() {
  const [cfg, setCfg] = useState(_cached);
  useEffect(() => {
    if (_cached) return;
    if (!_fetching) {
      _fetching = api.get("/config/fees").then(
        (r) => { _cached = r.data; return _cached; },
        () => { _cached = { invoice_card_fee_pct: 0, transaction_fee_pct: 0 }; return _cached; },
      );
    }
    _fetching.then((c) => setCfg(c));
  }, []);
  return cfg || { invoice_card_fee_pct: 0, transaction_fee_pct: 0 };
}

/** Small breakdown block used on Points / Custom Charge / Project Deposit pay pages.
 *  Shows the base, the fee, and the total charged with a nudge about offline pay. */
export function TransactionFeeBreakdown({ base, kind = "purchase", testid = "tx-fee-breakdown" }) {
  const { transaction_fee_pct } = useFeeConfig();
  if (!base || transaction_fee_pct <= 0) return null;
  const fee = Math.round(base * transaction_fee_pct) / 100;
  const total = Math.round((base + fee) * 100) / 100;
  return (
    <div className="border border-[#262626] bg-[#0a0a0a] p-4 space-y-1 text-sm" data-testid={testid}>
      <div className="text-[10px] uppercase tracking-[0.3em] text-[#a3a3a3] mb-2">Card checkout total</div>
      <div className="flex items-center justify-between text-[#a3a3a3]">
        <span>{kind === "invoice" ? "Invoice balance" : "Amount"}</span>
        <span className="tabular-nums text-white">${Number(base).toFixed(2)}</span>
      </div>
      <div className="flex items-center justify-between text-[#a3a3a3]">
        <span>Processing fee ({Number(transaction_fee_pct).toFixed(1)}%)</span>
        <span className="tabular-nums text-white">+ ${fee.toFixed(2)}</span>
      </div>
      <div className="flex items-center justify-between pt-2 border-t border-[#262626]">
        <span className="text-[10px] uppercase tracking-[0.3em] text-[#FF2D2D]">Charged to card</span>
        <span className="font-display text-xl tabular-nums text-white" data-testid={`${testid}-total`}>${total.toFixed(2)}</span>
      </div>
    </div>
  );
}
